export enum UsageSelectionEnum {
    NVT = 0,
    Meermalig = 1,
    Eenmalig = 2,
    Beiden = 3
}
